import React, { useId } from "react";
import { Button, Spinner } from "react-bootstrap";
import "./security.css";
import "./factorPills.css";

const ShieldIcon = ({ checked }) => (
  <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef8860"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" />
    {checked && <path d="M9 12l2 2 4-4" />}
  </svg>
);

// No recovery codes row or Regenerate since docs/specs/mfa-ux-cleanup.md §1: a lost phone is a support call.
const CardBody = ({ status, loading, error, onSetup, onReconfigure, onDisable, onRetry }) => {
  if (loading) {
    return <p><Spinner animation="border" size="sm" /> Loading authenticator settings...</p>;
  }
  if (error) {
    return <div><div className="alert alert-danger" role="alert">{error}</div><Button onClick={onRetry}>Retry</Button></div>;
  }
  if (status === "ACTIVE") {
    return (
      <>
        <p>You are asked for a code from your authenticator app when you sign in.</p>
        <div className="mfa-actions">
          <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" onClick={onReconfigure}>Reconfigure</Button>
          <Button variant="outline-secondary" className="mfa-btn-quiet mfa-btn-danger" type="button" onClick={onDisable}>Disable</Button>
        </div>
      </>
    );
  }
  return (
    <>
      <p>Use Google or Microsoft Authenticator for a code at sign-in instead of waiting for an email.</p>
      <div><Button type="button" className="text-white fw-bold" onClick={onSetup}>Set up Authenticator App</Button></div>
    </>
  );
};

// The "Authenticator App" card on My Profile -> Security: heading, On/Off status, then the body
// for the status (loading, error, active, or not set up). `recommended`: SMS is offered beside it (sms-factor.md §1).
const AuthenticatorCard = (props) => {
  const headingId = useId();
  const on = props.status === "ACTIVE";
  const known = !props.loading && !props.error;
  return (
    <section className="mfa-card" aria-labelledby={headingId}>
      <div className="mfa-card-head">
        <ShieldIcon checked={on} />
        <h2 id={headingId}>Authenticator App</h2>
        {props.recommended && <span className="mfa-pill is-recommended">Recommended</span>}
        {known && <span className={`mfa-pill${on ? " is-on" : ""}`}>{on ? "On" : "Off"}</span>}
      </div>
      <CardBody {...props} />
    </section>
  );
};

export default AuthenticatorCard;
